import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_BEGIN,
  COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_SUCCESS,
  COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_FAILURE,
  COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_DISMISS_ERROR,
} from './constants';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateCollectionDerivedFieldMapping(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_BEGIN,
    });

    const { projectId, version, mappingId, selectedCollection, updatedValues } = args;
    const { uuid: collectionUuid } = selectedCollection;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/utilties/${collectionUuid}/collection/update-derived-field-mapping/${mappingId}`,
        updatedValues,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Updated Derived Field Mapping in Collection');
          toast.success('Updated Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to update derived field mapping in collection');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCollectionDerivedFieldMappingError() {
  return {
    type: COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_BEGIN:
      return {
        ...state,
        updateCollectionDerivedFieldMappingPending: true,
        updateCollectionDerivedFieldMappingError: null,
      };

    case COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_SUCCESS:
      return {
        ...state,
        updateCollectionDerivedFieldMappingPending: false,
        updateCollectionDerivedFieldMappingError: null,
        derivedFieldMapping: action.data.derivedFieldMapping || [],
      };

    case COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_FAILURE:
      return {
        ...state,
        updateCollectionDerivedFieldMappingPending: false,
        updateCollectionDerivedFieldMappingError: action.data.error,
      };

    case COLLECTIONS_UPDATE_COLLECTION_DERIVED_FIELD_MAPPING_DISMISS_ERROR:
      return {
        ...state,
        dismissUpdateCollectionDerivedFieldMappingError: null,
      };

    default:
      return state;
  }
}
